module.exports = __webpack_public_path__ + "static/media/service_item_03.082b727e.png";